import { UserGender, UserProfile } from "@/generated-api";
import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
import GenderSelectCard from "@/components/onboarding/data-form/GenderSelectCard";
import UserDetailsForm from "./UserDetailsForm";

enum FormStep {
  GENDER = 1,
  INFO = 2,
}

export default function OnboardingForm({ user }: { user: UserProfile }) {
  const [step, setStep] = useState<FormStep>(
    user.gender ? FormStep.INFO : FormStep.GENDER
  );
  const [gender, setGender] = useState<UserGender | null>(user.gender || null);

  function handleSetGender(g: UserGender) {
    setGender(g);
    setStep(FormStep.INFO);
  }

  return (
    <>
      <AnimatePresence mode="wait">
        {gender === null || step === FormStep.GENDER ? (
          <motion.div
            key="gender"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 50 }}
            transition={{ duration: 0.1 }}
          >
            <GenderSelectCard gender={gender} setGender={handleSetGender} />
          </motion.div>
        ) : (
          <motion.div
            key="form"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -50 }}
            transition={{ duration: 0.1 }}
          >
            <UserDetailsForm
              gender={gender}
              user={user}
              back={() => setStep(FormStep.GENDER)}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
